import React, { useEffect } from "react";
import MasterIndustryTable from "./MasterIndustryTable";
import MasterIndustryAdd from "./MasterIndustryAdd";
import MasterIndustryEdit from "./MasterIndustryEdit";
import useApiNew from "../../../utils/useApiNew";
import axios from "axios";
import Breadcrumbs from "../../../components/ui/Breadcrumbs";
import DeleteAlert from "../../../components/ui/DeleteAlert";

import { errorNotify, successNotify } from "../../../Services/Notification";
import { actionPermissions } from "../../../components/authNavigation/AuthNavbar";

const industryApiURL = `${process.env.REACT_APP_API_URL}api/industry`;
const exportIndustryApiURL = `${process.env.REACT_APP_API_URL}api/export-industory`;

const MasterIndustry = () => {
  const [renderKey, setRenderKey] = React.useState(0);
  const [isAdd, setIsAdd] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [selectedItemId, setSelectedItemId] = React.useState();
  const [globalFilters, setGlobalFilters] = React.useState();
  const [bankData, setBankData] = React.useState();
  const [isButtonClicked, setIsButtonClicked] = React.useState();
  const [isDownloadClicked, setIsDownloadClicked] = React.useState();

  const triggerRerender = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  const { data, loading } = useApiNew(
    industryApiURL,
    "GET",
    { headers },
    renderKey,
  );

  const filterBankData = () => {
    let filterData = data;
    if (globalFilters) {
      filterData = data.filter(
        (item) =>
          item?.basic_industry
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.bi_code?.toLowerCase().includes(globalFilters?.toLowerCase()) ||
          item?.industry
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.industry_code
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.macro_economic_sector
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.mes_code
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.sector?.toLowerCase().includes(globalFilters?.toLowerCase()) ||
          item?.sector_code
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()),
      );
    }
    setBankData(filterData);
  };
  useEffect(() => {
    filterBankData();
  }, [globalFilters]);

  // ADD

  const handleAddIndustry = async (data) => {
    setIsButtonClicked(true);
    try {
      const res = await axios.post(industryApiURL, data, { headers });
      const resData = res.data;

      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // EDIT

  const handleEditIndustry = async (segmentId, data) => {
    setIsButtonClicked(true);
    const updateAPI = `${industryApiURL}/${segmentId}`;

    try {
      const res = await axios.put(updateAPI, data, { headers });
      const resData = res.data;
      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // DELETE

  const handleDeleteIndustry = async () => {
    const deleteAPI = `${industryApiURL}/${selectedItemId}`;
    try {
      const res = await axios.delete(deleteAPI, { headers });
      const resData = res.data;
      triggerRerender();
      if (!resData.error) {
        successNotify("Data deleted.");
        setIsDelete(false);
        return true;
      } else {
        errorNotify(resData?.message);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      return false;
    }
  };

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10);

  const downloadExcel = async (filename) => {
    try {
      const apiEndpoint = exportIndustryApiURL;
      const headers = {
        Authorization: `Bearer ${
          sessionStorage.getItem("subscriberToken")
            ? sessionStorage.getItem("subscriberToken")
            : sessionStorage.getItem("token")
        }`,
      };
      const response = await axios.get(apiEndpoint, {
        headers,
        responseType: "blob",
      });

      if (response && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename; // Set the filename here

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setIsDownloadClicked(false);
      } else {
        console.error("Invalid response or missing data");
        setIsDownloadClicked(false);
      }
    } catch (error) {
      errorNotify("Something went wrong.");
      setIsDownloadClicked(false);
    }
  };

  const downloadIndustry = () => {
    setIsDownloadClicked(true);
    const filename = `Industry-Master_${formattedDate}.xlsx`;
    downloadExcel(filename);
  };
  const breadcrumbs = ["Home", "Master", "Industry"];

  const buttonConfig = {
    value: "industry",
    name: "Industry",
    addHandler: handleAddIndustry,
    editHandler: handleEditIndustry,
    deleteHandler: handleDeleteIndustry,
    downloadHandler: downloadIndustry,
    closeAddModal: () => setIsAdd(false),
    closeEditModal: () => setIsEdit(false),
  };

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />
      <MasterIndustryTable
        tableData={globalFilters ? bankData : data}
        buttonConfig={buttonConfig}
        setIsAdd={setIsAdd}
        setIsEdit={setIsEdit}
        setIsDelete={setIsDelete}
        setSelectedItemId={setSelectedItemId}
        renderKey={renderKey}
        setGlobalFilters={setGlobalFilters}
        loading={loading}
        actionPermissions={actionPermissions("masters", "Industry")}
        isDownloadClicked={isDownloadClicked}
      />
      {isAdd && <MasterIndustryAdd buttonConfig={buttonConfig} isButtonClicked={isButtonClicked} />}
      {isEdit && (
        <MasterIndustryEdit
          buttonConfig={buttonConfig}
          selectedItemId={selectedItemId}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isDelete && (
        <DeleteAlert
          closeHandler={() => setIsDelete(false)}
          deleteHandler={buttonConfig.deleteHandler}
        />
      )}
    </div>
  );
};

export default MasterIndustry;
